import React, {useEffect, useState} from "react";
import ShareOptions from "./ShareOptions";

export default function Share({item, itemType, itemUrl, shareObj, extraContent, hoverBg, condenseOnMobile, gtmDataAttributes = {}}) {

    return (
        <div className={'dropdown'}>
            <a className={`dropdown-toggle p-2 link-secondary font-14 hover-bg-${hoverBg}`} data-bs-toggle={'dropdown'} data-bs-target={`#share_${item.id}`} {...gtmDataAttributes}>
                <i className={'fal me-2 fa-share'}></i>
                <span className={`fw-bold ${condenseOnMobile && 'd-none d-sm-inline-block'}`}>Share</span>
            </a>
            <div className={'dropdown-menu dropdown-menu-end rounded font-13 py-1 mt-2'} id={`#share_${item.id}`}>
                <div className={'d-flex justify-content-end px-2 fs-6'} style={{gap: '20px'}}>
                    <ShareOptions
                        shareObj={shareObj}
                        itemId={item.id}
                        itemType={itemType}
                        itemUrl={itemUrl}
                        extraContent={extraContent}></ShareOptions>
                </div>
            </div>
        </div>
    )
}